module.exports = __webpack_public_path__ + "static/media/playMusic.ed7fcdf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/music/playMusic.mp3
// module id = RDrf
// module chunks = 34